<template>
  <div>
    <div
      v-if="provider.install_instructions"
      class="pb-2"
    >
      <b-alert
        variant="secondary"
        show
        class="w-100 mb-2"
      >
        <div class="alert-body">
          <p
            v-for="(instruction,k) in provider.install_instructions"
            :key="`instruction-${k}`"
          >
            <span v-html="instruction" />
          </p>
        </div>
      </b-alert>
    </div>
    <b-row
      v-if="gatewayConfigs && gatewayConfigs.length"
      class="pb-2"
    >
      <b-col
        cols="12"
        class="mb-2"
      >
        <h5
          class="mb-0"
        >
          {{ $t('modules.payment_methods._create.tabs.integration_data_gateway_configs_title') }}
        </h5>
        <small class="text-muted">{{ $t('modules.payment_methods._create.tabs.integration_data_gateway_configs_subtitle', {provider: provider.name}) }}</small>
      </b-col>
      <b-col
        v-for="config in gatewayConfigs"
        :key="config.id"
        :md="config.cols || 6"
      >
        <i-input
          :id="config.id"
          :ref="config.id"
          v-model="value.gateway_configs[config.id]"
          :errors="validationErrors.name"
          :type="config.type || 'text'"
          :title="config.label || $t(`modules.payment_methods.inputs.$providers.${provider.code}.${config.id}`)"
          :placeholder="config.placeholder || ' '"
          :description="config.description || ''"
          :required="Object.hasOwn(config, 'required') ? config.required : true"
          :append="config.append || null"
          :prepend="config.prepend || null"
        />
      </b-col>
      <b-col
        v-if="gatewayConfigs.length % 2"
        md="6"
      />
    </b-row>
    <hr v-if="networkConfigs && networkConfigs.length">
    <b-row
      v-if="networkConfigs && networkConfigs.length"
      class="pb-2"
    >
      <b-col
        cols="12"
        class="mb-2"
      >
        <h5
          class="mb-0"
        >
          {{ $t('modules.payment_methods._create.tabs.integration_data_network_configs_title') }}
        </h5>
        <small class="text-muted">{{ $t('modules.payment_methods._create.tabs.integration_data_network_configs_subtitle', {network: network.name}) }}</small>
      </b-col>
      <b-col
        v-for="config in networkConfigs"
        :key="config.id"
        :md="config.cols || 6"
      >
        <i-input
          :id="config.id"
          :ref="config.id"
          v-model="value.network_configs[config.id]"
          :errors="validationErrors.name"
          :type="config.type || 'text'"
          :title="config.label || $t(`modules.payment_methods.inputs.$providers.${provider.code}.$networks.${network.code}.${config.id}`)"
          :placeholder="config.placeholder || ' '"
          :description="config.description || ''"
          :required="Object.hasOwn(config, 'required') ? config.required : true"

          v-bind="config.flags || {}"
        />

        <Transition name="list-enter-up">
          <b-alert
            v-for="(alert, index) in alerts(config)"
            :key="`alert-${index}`"
            :variant="alert.type"
            class="mb-1"
            show
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="InfoIcon"
              />
              <span class="ml-25">{{ alert.text }}</span>
            </div>
          </b-alert>
        </Transition>
      </b-col>
      <b-col
        v-if="(networkConfigs.length > 1) && networkConfigs.length % 2"
        md="6"
      />
    </b-row>
  </div>
</template>

<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { heightTransition } from '@core/mixins/ui/transition'

import {
  BRow,
  BCol, BLink, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BAlert,
    BLink,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    provider: {
      type: Object,
      required: true,
      default: Object,
    },
    value: {
      type: Object,
      required: false,
      default: Object,
    },
    gatewayConfigs: {
      type: Array,
      required: false,
      default: Array,
    },
    networkConfigs: {
      type: Array,
      required: false,
      default: Array,
    },
  },
  computed: {
    network() {
      return this.provider?.networks?.[0] || null
    },
  },
  mounted() {
  },
  setup(props, ctx) {
    const alerts = input => {
      if (!Object.hasOwn(input, 'alerts') || !(input.alerts instanceof Array) || !input.alerts.length) {
        return []
      }
      return input.alerts/* .filter(alert => !Object.hasOwn(alert, 'hideIf') || !evaluateConditions(alert.hideIf, false)) */
    }

    return {
      validationErrors: {},
      alerts,
    }
  },
}
</script>
